import React from "react";
import "./PastEvents.css";
import { Link } from "react-router-dom";

const AaiifaEvent2024 = () => {
  const events = [
    {
      year: "2025",
      title: "Day 1 2025",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2024/day1-2024/1.jpg",
      link: "/day-1-2025",
    },
    {
      year: "2025",
      title: "Day 2 2025",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2025/day-2/3.JPG",
      link: "/day-2-2025",
    },
  ];

  return (
    <>
      
      <section className="past-events-section">
        <div className="past-events-container">
          <div className="past-events-header">
            <p className="past-events-subtitle">2025 Aaiifa Event</p>
          </div>

          <div className="past-events-grid">
  {events.map((event, index) => (
    <Link
      to={event.link}
      className="past-event-card"
      key={index}
    >
      <div className="past-event-image">
        <img src={event.img} alt={event.title} />
      </div>
      <div className="past-event-title-bar">
        <h3>{event.title}</h3>
      </div>
    </Link>
  ))}
</div>
        </div>
      </section>
    </>
  );
};

export default AaiifaEvent2024;
